import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { CUSTOMER_ADDRESS_API } from '@shared/constants/api.constants';
import { CustomerAddressSearch } from '@shared/models/customer-address/customer-address.model';
import { Observable } from 'rxjs';
import { CustomerAddressPayload } from '@shared/models/customer-address/customer-address.model';
import { ActiveShipToWithProducts, CustomerAddressProductLookup } from '@shared/models/customer-address/customer-address.model';
import { clampCustomerAddressSearchPageSize } from '@shared/utilities/common.utils';

@Injectable({
  providedIn: 'root'
})
export class CustomerAddressService {

  constructor(
    private http: HttpService
  ) { }

  getCustomerAddresses(payload: CustomerAddressPayload): Observable<CustomerAddressSearch> {
    return this.http.post(CUSTOMER_ADDRESS_API.SEARCH, {
      ...payload,
      pageSize: clampCustomerAddressSearchPageSize(payload.pageSize),
    });
  }

  getActiveWithProducts(params: {
    clientId: string;
    customerId: number;
  }): Observable<ActiveShipToWithProducts[]> {
    return this.http.get<ActiveShipToWithProducts[]>(
      CUSTOMER_ADDRESS_API.ACTIVE_WITH_PRODUCTS,
      params
    );
  }

  getProductsLookup(params: {
    clientId: string;
    customerId: number;
    customerAddressId?: number;
  }): Observable<CustomerAddressProductLookup[]> {
    return this.http.get<CustomerAddressProductLookup[]>(
      CUSTOMER_ADDRESS_API.PRODUCTS_LOOKUP,
      params
    );
  }
}
